import * as _ from 'lodash';
import UserStore from '../../../stores/UserStore';
import PosActions from '../../../actions/PosActions';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';
import AjaxPromises from '../../../utils/AjaxPromises';
import NotificationActions from '../../../actions/NotificationActions';
import InputProfile from './InputProfile.react';
import DropdownProfile from './DropdownProfile.react';
import InputDate from '../../form/input/InputDate.react';
import { TypeAheadDDWithProducts } from '../../form/dropdown/TypeAheadWithProducts.react';
import TextareaProfile from './TextareaProfile.react';
import moment from 'moment';

export default class Prescriptions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            prescriptions: [],
            selected: false,
            prescriptionDate: '',
            note: '',
            completedDate: '',
            expirationDate: '',
            quantity: '',
            unit: '',
            productId: null,
        };

        this.saveOrUpdate = this.saveOrUpdate.bind(this);
        this.completePrescription = this.completePrescription.bind(this);
        this.getPrescriptions = this.getPrescriptions.bind(this);
        this.isValid = this.isValid.bind(this);
        this.updateDates = this.updateDates.bind(this);
        this.loadPrescription = this.loadPrescription.bind(this);
        this.addNewPrescription = this.addNewPrescription.bind(this);
        this.delete = this.delete.bind(this);
        this.formatYesNo = this.formatYesNo.bind(this);
        this.baseState = this.state;
    }

    componentDidMount() {
        this.getPrescriptions();
        PosActions.loadProducts();
    }

    getPrescriptions() {
        AjaxPromises.POST(GuestEndPoints.GET_PRESCRIPTIONS, UserStore.getApiData({
            AcctId: this.props.guest.Guest_id,
        })).then(res => {
            if (res.Result) {
                this.setState({ prescriptions: res.Data });
            } else {
                NotificationActions.error('Error loading prescriptions');
            }
        });
    }

    isValid() {
        let valid = true;

        if (!this.state.prescriptionDate) {
            NotificationActions.error('Please enter a prescription date');
            valid = false;
        }

        if (!this.state.expirationDate) {
            NotificationActions.error('Please enter an expiration date');
            valid = false;
        }

        if (!this.state.completedDate && this.state.selected) {
            NotificationActions.error('Please enter a completion date');
            valid = false;
        }


        return valid;
    }

    completePrescription() {

        if (!this.isValid()) {
            return;
        }

        AjaxPromises.POST(GuestEndPoints.COMPLETE_PRESCRIPTION, UserStore.getApiData({
            PrescriptionId: this.state.selected.PrescriptionId,
            completedDate: this.state.completedDate,
        })).then(res => {
            if (res.Result) {
                NotificationActions.success('Prescription successfully completed');
                this.getPrescriptions();
            } else {
                NotificationActions.error('Error completing prescriptions');
            }
        });
    }

    saveOrUpdate() {
        if (!this.isValid()) {
            return;
        }

        AjaxPromises.POST(GuestEndPoints.ADD_PRESCRIPTION, UserStore.getApiData({
            PrescriptionId: this.state.selected.PrescriptionId ? this.state.selected.PrescriptionId : 0,
            AcctId: this.props.guest.Guest_id,
            PrescriptionDate: this.state.prescriptionDate,
            ExpirationDate: this.state.expirationDate,
            completedDate: this.state.completedDate,
            Note: this.state.note,
            Quantity: this.state.quantity,
            UnitId: this.state.unit,
            ProductId: this.state.productId ? this.state.productId : null,
            StateRXSerialNumber: this.state.StateRXSerialNumber,
            ElectronicPrescription: this.state.ElectronicPrescription,
            DoseId: this.state.DoseId,
        })).then(res => {
            if (res.Result) {
                NotificationActions.success(`${this.state.selected ? 'Prescription successfully saved' : 'Prescription successfully added'}`);
                this.getPrescriptions();
            } else if (res.Message) {
                NotificationActions.error(res.Message);
            } else {
                NotificationActions.error(`${this.state.selected ? 'Error saving prescription' : 'Error adding prescription'}`);
            }
        });
    }

    delete() {

        AjaxPromises.POST(GuestEndPoints.DELETE_PRESCRIPTION, UserStore.getApiData({
            PrescriptionId: this.state.selected.PrescriptionId,
        })).then(res => {
            if (res.Result) {
                NotificationActions.success('Prescription deleted');
                this.addNewPrescription();
                this.getPrescriptions();
            } else if (res.Message) {
                NotificationActions.error(res.Message);
            } else {
                NotificationActions.error('Error deleting prescription');
            }
        });
    }

    updateDates(date) {
        this.setState({ prescriptionDate: date });
        let yearFromNowMinusOneDay = moment(date).add(1, 'Y').subtract(1, 'd').format('YYYY-MM-DD');
        this.setState({ expirationDate: yearFromNowMinusOneDay });
    }

    loadPrescription(prescription) {
        this.setState({
            selected: prescription,
            prescriptionDate: moment(prescription.PrescriptionDate).format('YYYY-MM-DD'),
            note: prescription.Note,
            completedDate:  prescription.CompletedDate ? moment(prescription.CompletedDate).format('YYYY-MM-DD') : '',
            expirationDate: moment(prescription.ExpirationDate).format('YYYY-MM-DD'),
            quantity: prescription.Quantity,
            unit: prescription.UnitId,
            productId: prescription.ProductId,
            PrescriptionId: prescription.PrescriptionId,
            StateRXSerialNumber: prescription.StateRXSerialNumber,
            ElectronicPrescription: prescription.ElectronicPrescription,
            DoseId: prescription.DoseId,
        });
    }

    addNewPrescription() {
        this.setState({
            selected: false,
            prescriptionDate: '',
            note: '',
            completedDate:  '',
            expirationDate: '',
            quantity: '',
            unit: '',
            productId: null,
            PrescriptionId: null,
        });
    }

    formatYesNo(val) {
        if(val === true) {
            return 'Yes';
        } else if(val === false) {
            return 'No';
        }

        return '';
    }

    render() {
        let prescriptions = this.state.prescriptions || [];
        const { selectedLocation } = UserStore.getState();

        return (
            <div className='container prescriptions-container'>
                <div className='row prescriptions__date'>
                    <div className='col-3 prescriptions__input'>
                        <div className='prescriptions__label'>
                            Prescription Date *
                        </div>
                    </div>
                    <div className='col-7'>
                        <InputDate
                            required
                            value={this.state.prescriptionDate}
                            onChange={prescriptionDate => { this.updateDates(prescriptionDate); }} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-3 prescriptions__input'>
                        <div className='prescriptions__label'>
                            Expiration Date *
                        </div>
                    </div>
                    <div className='col-7'>
                        <InputDate
                            required
                            value={this.state.expirationDate}
                            onChange={expirationDate => { this.setState({ expirationDate }); }} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-3 prescriptions__input'>
                        <div className='prescriptions__label'>
                            Note
                        </div>
                    </div>
                    <div className='col-7'>
                        <textarea
                            value={this.state.note}
                            className={'input-text-1 '}
                            placeholder='Note'
                            onChange={(e) => { this.setState({ note: e.target.value }); }}
                            />
                    </div>
                </div>
                {selectedLocation.State !== 'OH' &&
                    <div>
                        <div className='row'>
                            <div className='col-3 prescriptions__input'>
                                <div className='prescriptions__label'>
                                    Product
                                </div>
                            </div>
                            <div className='col-7'>
                                <TypeAheadDDWithProducts 
                                    value={parseInt(this.state.productId)}
                                    onChange={productId => this.setState({productId})}
                                    showDetail
                                    limitItems={100}
                                    onlyProducts
                                />
                            </div>
                        </div>                
                        <div className='row'>
                            <div className='col-3 prescriptions__input'>
                                <div className='prescriptions__label'>
                                    Quantity
                                </div>
                            </div>
                            <div className='col-5 prescriptions__input--quantity'>
                                <InputProfile
                                    field='quantity'
                                    value={this.state.quantity}
                                    onChange={(field, quantity) => { this.setState({ quantity }); }} />
                            </div>
                            <div className='col-2 prescriptions__input--units'>
                                <DropdownProfile
                                    field='unit'
                                    options={[
                                        { title: '', option: null },
                                        { title: 'qty', option: 1 },
                                        { title: 'ml', option: 2 },
                                        { title: 'g', option: 3 },
                                        { title: 'Gal', option: 4 },
                                        { title: 'L', option: 5 },
                                        { title: 'lb', option: 6 },
                                        { title: 'mg', option: 7 },
                                        { title: 'oz', option: 8 },
                                        { title: 'fl oz', option: 9 },
                                        { title: 'kg', option: 10 },
                                    ]}
                                    selected={this.state.unit}
                                    onChange={(field, unit) => { this.setState({ unit }); }} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-3 prescriptions__input'>
                                <div className='prescriptions__label'>
                                    State RX Number
                                </div>
                            </div>
                            <div className='col-7 prescriptions__input'>
                                <InputProfile
                                    field='State RX Number'
                                    value={this.state.StateRXSerialNumber}
                                    onChange={(field, StateRXSerialNumber) => { this.setState({ StateRXSerialNumber }); }} />
                            </div>
                        </div>
                        {selectedLocation.State === 'NY' &&
                            <div className='row'>
                                <div className='col-3 prescriptions__input'>
                                    <div className='prescriptions__label'>
                                        Dose ID
                                    </div>
                                </div>
                                <div className='col-7 prescriptions__input'>
                                    <InputProfile
                                        field='Dose ID'
                                        value={this.state.DoseId}
                                        onChange={(field, DoseId) => { this.setState({ DoseId }); }} />
                                </div>
                            </div>
                        }
                        <div className='row'>
                            <div className='col-3 prescriptions__input'>
                                <div className='prescriptions__label'>
                                    Electronic Prescription
                                </div>
                            </div>
                            <div className='col-7 prescriptions__input'>
                            <DropdownProfile
                                    field='Electronic Prescription'
                                    options={[
                                        { title: '', option: null },
                                        { title: 'Yes', option: true },
                                        { title: 'No', option: false },
                                    ]}
                                    selected={this.state.ElectronicPrescription}
                                    onChange={(field, ElectronicPrescription) => { this.setState({ ElectronicPrescription }); }} />
                            </div>
                            
                        </div>
                    </div>
                }
                {this.state.selected && 
                    <div className='row'>
                        <div className='col-3 prescriptions__input'>
                            <div className='prescriptions__label'>
                                Completed Date
                            </div>
                        </div>
                        <div className='col-7'>
                            <InputDate
                                value={this.state.completedDate}
                                onChange={completedDate => { this.setState({ completedDate }); }} />
                        </div>
                    </div>
                }
                <div className='row justify-content-end'>
                    {(this.state.selected && this.state.selected.CompletedDate == null) &&
                        <div className='prescriptions__save'>
                            <button className='btn-green prescriptions__save--btn'
                                onClick={this.completePrescription} >
                                Complete
                            </button>
                        </div>
                    }
                    <div className={`${!this.state.selected ? 'col-3' : ''} prescriptions__save`}>
                        <button className='btn-green prescriptions__save--btn'
                            onClick={this.saveOrUpdate} >
                            Save
                        </button>
                    </div>
                    {this.state.selected &&
                        <div className='col-3 prescriptions__save'>
                            <button className='btn-green prescriptions__save--btn'
                                onClick={this.delete} >
                                Delete
                            </button>
                        </div>
                    }
                </div>
                <div className='prescription-entries'>
                    <i
                        className='fa fa-plus'
                        aria-hidden='true'
                        title='Add new prescription'
                        onClick={ () => { this.addNewPrescription();}} />
                <div className='prescription-entries__list'>
                    <table className='table-1'>
                        <thead>
                            <tr>
                                <th>Rx Number</th>
                                <th>Prescription Date</th>
                                <th>Completed Date</th>
                                <th>Note</th>
                                {selectedLocation.State !== 'OH' &&
                                    <th>Quantity</th>
                                }
                                <th>Doctor</th>
                                <th>State RX#</th>
                                <th>Electronic</th>
                                {selectedLocation.State === 'NY' &&
                                    <th>Dose ID</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {prescriptions.map((prescription, index) => {
                                return (
                                    <tr
                                        className={this.state.selected && this.state.selected.PrescriptionId === prescription.PrescriptionId ? 'table-1__selected' : ''}
                                        onClick={() => { this.loadPrescription(prescription);}}
                                        key={index}>

                                        <td>{prescription.PrescriptionNumber}</td>
                                        <td>{`${prescription.PrescriptionDate ? moment(prescription.PrescriptionDate).format('MM-DD-YYYY') : ''} - ${prescription.ExpirationDate ? moment(prescription.ExpirationDate).format('MM-DD-YYYY') : ''}`}</td>
                                        <td>{prescription.CompletedDate == null ? '' : moment(prescription.CompletedDate).format('MM-DD-YYYY')}</td>
                                        <td>{prescription.Note ? prescription.Note : ''}</td>
                                        {selectedLocation.State !== 'OH' &&
                                            <td>{`${prescription.Quantity ? prescription.Quantity : 0} ${prescription.abbreviation ? prescription.abbreviation : ''}`}</td>
                                        }
                                        <td>{prescription.DoctorsName ? prescription.DoctorsName : ''}</td>
                                        <td>{prescription.StateRXSerialNumber ? prescription.StateRXSerialNumber : ''}</td>
                                        <td>{this.formatYesNo(prescription.ElectronicPrescription)}</td>
                                        {selectedLocation.State === 'NY' &&
                                            <td>{prescription.DoseId}</td>
                                        }
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/Prescriptions.react.jsx